import { render, staticRenderFns } from "./DeviceLogTable.vue?vue&type=template&id=0876d4dd&scoped=true"
import script from "./DeviceLogTable.vue?vue&type=script&lang=js"
export * from "./DeviceLogTable.vue?vue&type=script&lang=js"
import style0 from "./DeviceLogTable.vue?vue&type=style&index=0&id=0876d4dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0876d4dd",
  null
  
)

export default component.exports